import { Map as PigeonMap } from "pigeon-maps";

import "../assets/scss/components/_map.scss";
import type { MapProps } from "../types/components/MapProps";

export const Map = ({ lat, long, height = 200, zoom = 14 }: MapProps) => {
	return (
		<div className="map-container">
			<PigeonMap
				height={height}
				defaultCenter={[54.018105, -2.005736]}
				defaultZoom={5}
				center={[lat, long]}
				zoom={zoom}
				mouseEvents={false}
				attribution={false}
				touchEvents={false}
			></PigeonMap>
		</div>
	);
};
